import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';
import { push } from 'react-router-redux';

import * as reservasActions from 'modules/reservas/action';
import * as generalActions from 'modules/general/action';

moment.locale('es');

@connect((store, props) => ({
  probable: props.params.probable == 'true',
  reservasPendientes: store.getIn(['reservas', 'reservasPendientes']),
  reservasProbables: store.getIn(['reservas', 'reservasProbables']),
  loading: store.getIn(['general', 'loadingbar', 'show']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    const { probable } = this.props;
    this.props.dispatch(generalActions.dashboard_changeTitle(probable ? 'RESERVAS PROBABLES' : 'RESERVAS PENDIENTES'));
    if (probable) this.props.reservasProbables.size == 0 && this.props.dispatch(reservasActions.getReservasPendientes(true));
    else this.props.reservasPendientes.size == 0 && this.props.dispatch(reservasActions.getReservasPendientes());
  };
  componentDidUpdate = prevProps =>
    this.props.probable != prevProps.probable && this.props.dispatch(generalActions.dashboard_changeTitle(this.props.probable ? 'RESERVAS PROBABLES' : 'RESERVAS PENDIENTES'));
  render() {
    let { reservasPendientes, reservasProbables, probable, dispatch } = this.props;
    const reservas = (probable ? reservasProbables : reservasPendientes).groupBy(r => moment(r.get('horario')).format('YYYY-MM-DD')).sortBy((data, fecha) => moment(fecha).valueOf());
    return (
      <Container fluid={true}>
        <MaterialUI.Paper zDepth={2} className="container">
          <MaterialUI.List className="noPadding">
            <MaterialUI.ListItem
              className="pt-10"
              primaryText={
                <Row className="textCenter">
                  <Col md="3">Nombre</Col>
                  <Col md="2">Parada de salida</Col>
                  <Col md="2">Trayecto</Col>
                  <Col md="2">Horario</Col>
                </Row>
              }
              rightIconButton={<MaterialUI.RaisedButton label="ok" className="hidden" />}
            />
            <MaterialUI.Divider />
            {reservas.entrySeq().map((data, i) => (
              <div key={data[0] + i}>
                <h3 className="pt-10">{moment(data[0]).format('DD/MM/YY')}</h3>
                {data[1]
                  .sortBy(r => r.get('horario'))
                  .map((reserva, i) => (
                    <MaterialUI.ListItem
                      key={i}
                      className="pt-10"
                      primaryText={
                        <Row className="textCenter">
                          <Col md="3">
                            <MaterialUI.RaisedButton
                              primary
                              label={
                                reserva.get('_usuario')
                                  ? reserva.getIn(['_usuario', 'nombre']) + ' ' + reserva.getIn(['_usuario', 'apellido'])
                                  : reserva.getIn(['_usuarioAbonado', 'nombre']) + ' ' + reserva.getIn(['_usuarioAbonado', 'apellido'])
                              }
                              icon={<FontAwesome name="user" style={{ color: 'white' }} />}
                              onClick={() =>
                                dispatch(
                                  push(`/dashboard/abonados/add/${reserva.get('usuarioId') ? reserva.get('usuarioId') : reserva.get('abonadoId')}/${reserva.get('usuarioId') ? 'true' : 'false'}`),
                                )
                              }
                            />
                          </Col>
                          <Col md="2">{reserva.getIn(['_paradaSubida', 'alias']) ? reserva.getIn(['_paradaSubida', 'alias']) : reserva.getIn(['_paradaSubida', 'nombre'])}</Col>
                          <Col md="2">{reserva.getIn(['_trayecto', 'nombre']) + ' - ' + (reserva.getIn(['_trayecto', 'subnombre']) || '')}</Col>
                          <Col md="2">{moment(reserva.get('horario')).format('HH:mm')}</Col>
                          <Col md="3">
                            {probable ? (
                              <MaterialUI.RaisedButton
                                secondary
                                label="Crear reserva"
                                icon={<FontAwesome name="ticket" style={{ color: 'white' }} />}
                                onClick={() => dispatch(reservasActions.tryProbable(reserva.get('id')))}
                              />
                            ) : (
                              <div />
                            )}
                          </Col>
                        </Row>
                      }
                    />
                  ))}
                <MaterialUI.Divider />
              </div>
            ))}
          </MaterialUI.List>
        </MaterialUI.Paper>
        <Row className="pt-50 textCenter">
          <Col md={{ size: 10, offset: 1 }}>
            {probable
              ? 'Las reservas probables son reservas automaticas que no se pudieron crear y ya no se crearan por si solas'
              : 'Las reservas pendientes son reservas automaticas que no se pudieron crear y en caso de que se haga un lugar en el viaje, creara la reserva por si sola, como una cola de espera'}
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/reservas/components/reservaPendiente.js